import LoadingButton from '@mui/lab/LoadingButton'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
const ConfirmModal = ({
  isOpen,
  setIsOpen = () => {},
  title,
  text,
  txtConfirm = 'Ok',
  txtCancel = 'Annuler',
  className,
  dismissable = true,
  onConfirm = () => {},
  onCancel = () => {},
  closeOnConfirm = true,
  isLoading = false,
  hideCancel = false,
}) => {
  const cancel = (_, reason) => {
    const isDismissEvent = reason === 'backdropClick' || reason === 'escapeKeyDown'
    if (dismissable || (!dismissable && !isDismissEvent)) {
      setIsOpen(false)
      !!onCancel && onCancel()
    }
  }

  const confirm = () => {
    closeOnConfirm && setIsOpen(false)
    !!onConfirm && onConfirm()
  }

  return (
    <Dialog open={isOpen} onClose={cancel} className={className}>
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>{text}</DialogContent>
      <DialogActions>
        {!hideCancel && (
          <LoadingButton onClick={cancel} loading={isLoading}>
            {txtCancel}
          </LoadingButton>
        )}
        <LoadingButton onClick={confirm} loading={isLoading}>
          {txtConfirm}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
export default ConfirmModal
